import React from 'react';

import { IconButton } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { Modal, CustomModalActions, CustomModalTitle, StyledModalTitle, CustomModalDescription } from './styles';
import { CustomModalProps } from './types';

const CustomModal: React.FunctionComponent<CustomModalProps> = ({
  onClose,
  openModal,
  modalTitle,
  modalDescription,
  children,
  cancelButton,
  submitButton,
  modalWidth,
  buttonsSpacing,
  disableClose = false,
}): React.ReactElement => {
  const titleId = React.useId();

  return (
    <Modal
      aria-labelledby={titleId}
      onClose={disableClose ? undefined : onClose}
      open={openModal}
      maxWidth={modalWidth || 'sm'}
      fullWidth
      disableEscapeKeyDown={disableClose}
      PaperProps={{
        square: true,
        elevation: 0,
      }}
    >
      <CustomModalTitle>
        <StyledModalTitle id={titleId}>{modalTitle}</StyledModalTitle>
        {onClose && !disableClose ? (
          <IconButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        ) : null}
      </CustomModalTitle>
      {modalDescription ? <CustomModalDescription>{modalDescription}</CustomModalDescription> : null}
      {children}
      {cancelButton || submitButton ? (
        <CustomModalActions $buttonsSpacing={buttonsSpacing}>
          {cancelButton}
          {submitButton}
        </CustomModalActions>
      ) : null}
    </Modal>
  );
};

export default CustomModal;
